import { Nav, NavItem, NavLink } from "reactstrap";
import { ComparativeScatter } from "./ComparativeScatter/ComparativeScatter";
import { GenotypeAnalyzer } from "./GenotypeAnalyzer";
import { HistogramChart } from "./HistogramChart";
import { ModalityProfiler } from "./ModalityProfiler";
import PropTypes from "prop-types";
import { formatDate } from "../../../utils";
import { useSelector } from "react-redux";
import { useState } from "react";

/*
 * MultipleChart is used to display different charts under tabs you can choose from
 */
export const MultipleChart = ({
  displayTabs,
  selectedTrait,
  plotRatingConfig,
}) => {
  const [selectedDate, trial] = useSelector(({ resultMap }) => [
    resultMap.trial_date,
    resultMap.trial,
  ]);

  const tabs = [
    { name: "Genotype Analyzer", icon: "fa-list-ol" },
    { name: "Attribute Profiler", icon: "fa-tag" },
    {
      name: "Comparative Scatter",
      icon: "fa-scale-balanced",
      disabled: !Boolean(trial),
    },
    { name: "Plot distribution", icon: "fa-chart-column" },
  ];

  const [selectedChart, setSelectedChart] = useState(tabs[0].name);

  // Lifted the state up for scatter tool in order to keep choices when changing tabs
  const [xAxis, setXAxis] = useState(selectedTrait.technical_name);
  const [yAxis, setYAxis] = useState(selectedTrait.technical_name);
  const [showRegression, setShowRegression] = useState(true);
  const [scatterOpacity, setScatterOpacity] = useState(0.5);

  return (
    <>
      {displayTabs && (
        <Nav tabs className="analytics-tabs">
          {tabs.map(({ name, icon, disabled }) => (
            <NavItem key={name}>
              <NavLink
                className={name === selectedChart ? "active" : ""}
                disabled={disabled}
                onClick={() => setSelectedChart(name)}
              >
                <i className={`fa-solid ${icon}`} /> {name}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
      )}
      {selectedChart === "Genotype Analyzer" && (
        <GenotypeAnalyzer
          trait={selectedTrait}
          exportName={`gen_ranking_${trial?.display_name}_${
            selectedTrait.name
          }${selectedTrait.isAddon ? "" : `_${formatDate(selectedDate)}`}`}
        />
      )}
      {selectedChart === "Attribute Profiler" && (
        <ModalityProfiler
          trait={selectedTrait}
          exportName={`attribute_performance_${
            trial?.display_name
          }_${formatDate(selectedDate)}`}
        />
      )}
      {selectedChart === "Comparative Scatter" && (
        <ComparativeScatter
          exportName={`comparative_scatter_${trial?.display_name}_${formatDate(
            selectedDate
          )}`}
          plotRatingConfig={plotRatingConfig}
          xAxis={xAxis}
          setXAxis={setXAxis}
          yAxis={yAxis}
          setYAxis={setYAxis}
          showRegression={showRegression}
          setShowRegression={setShowRegression}
          scatterOpacity={scatterOpacity}
          setScatterOpacity={setScatterOpacity}
        />
      )}
      {selectedChart === "Plot distribution" && (
        // An AUC trait has no distribution of its own: show its base trait.
        <HistogramChart
          trait={
            selectedTrait.isAddon ? selectedTrait.baseTrait : selectedTrait
          }
          exportName={`plot_distribution_${trial?.display_name}_${
            selectedTrait.name
          }${selectedTrait.isAddon ? "" : `_${formatDate(selectedDate)}`}`}
        />
      )}
    </>
  );
};

MultipleChart.propTypes = {
  displayTabs: PropTypes.bool,
  selectedTrait: PropTypes.object,
  plotRatingConfig: PropTypes.array,
};
